<template>
  <div class="wrap">
    <myHead></myHead>
    <div class="wrap_body">
      <div class="center">
        <div class="ucenter_main">
          <ucMenu num="32"></ucMenu>
          <div class="right_con">
            <div class="rc_main">
              <p class="fb">低价引流检测</p>
              <el-tabs v-model="activeTab" @tab-click="handleTabChange">
                <el-tab-pane label="检测内容" name="checkLowerPrice">
                  <check-LowerPrice ref="checkLowerPriceRef"></check-LowerPrice>
                </el-tab-pane>
                <el-tab-pane label="检测列表" name="checkLowerList">
                  <sku-Check-List ref="skuCheckListRef"></sku-Check-List>
                </el-tab-pane>
                <el-tab-pane label="检测异常" name="checkAbnormalList">
                  <sku-Check-Abnormal-List ref="skuCheckAbnormalListRef"></sku-Check-Abnormal-List>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
    <myFoot></myFoot>
  </div>
</template>
<script >

import myHead from "@/components/myHead/myhead.vue";
import myFoot from "@/components/myFoot/myfoot.vue";
import ucMenu from "@/components/ucenterMenu/ucmenu.vue";
import checkLowerPrice from "./checkLowerPrice.vue";
import skuCheckList from "./skuCheckList.vue";
import skuCheckAbnormalList from "./skuCheckAbnormalList.vue";



export default ({
  name: 'ucenterCheckSku',
  data(){
    return {
        activeTab: 'checkLowerPrice',
        task_no: '',
    }
  },
  components: {ucMenu, myFoot, myHead, checkLowerPrice, skuCheckList, skuCheckAbnormalList},
    // mounted() {
    // this.task_no = this.$route.query.task_no
    // if(this.task_no){
    //     this.activeTab = 'checkAbnormalList'
    // }
    // this.handleTabChange({name:this.activeTab})
    // // window.addEventListener('keydown', this.handleKeydown);

    // },
    beforeRouteUpdate(to, from, next) {
        // 【关键】只要跳转就执行，不管地址是否相同
        const task_no = to.query.task_no || ''

        if (task_no) {
            this.activeTab = 'checkAbnormalList'
            this.task_no = task_no

        this.$nextTick(() => {
            if (this.$refs.skuCheckAbnormalListRef) {
                this.$refs.skuCheckAbnormalListRef.initData(task_no)
            }
        })
    }
    next()
    },
  beforeDestroy() {
    // window.removeEventListener('keydown', this.handleKeydown);
    },
    // 第一次进入页面也要执行
    mounted() {
    const task_no = this.$route.query.task_no || ''
    if (task_no) {
        this.activeTab = 'checkAbnormalList'
        this.task_no = task_no

        this.$nextTick(() => {
        if (this.$refs.skuCheckAbnormalListRef) {
            this.$refs.skuCheckAbnormalListRef.initData(task_no)
        }
        })
    }
    },
  methods:{
    handleTabChange(tab) {
        // 切换 tab 时 → 清空 URL 里的 task_no 参数
        this.$router.replace({ query: {} }).catch(() => {});
        // 同时清空 data 里的 task_no
        this.task_no = '';
        this.activeTab = tab.name;
        this.$nextTick(()=>{
            if(tab.name === 'checkLowerList'){
                this.$refs.skuCheckListRef.initData()
            }else if(tab.name === 'checkAbnormalList'){
                this.$refs.skuCheckAbnormalListRef.initData(this.task_no)
            }
        })
    },
    handleKeydown(event) {
      if(this.activeTab=='alien'){
        if (event.key === 'q'||event.key === 'Q'||event.key === 'e'||event.key === 'E') {
          this.$nextTick(()=>{
            this.$refs.alienCheckRef.handlePreOrNext(event.key)
          })
        }
      }
    },
  }
})
</script>


<style scoped>
.wrap {
  overflow-x: hidden;
}

.wrap .wrap_body {
  display: flex;
  flex-direction: column;
}

.center {
  display: flex;
  flex: 1;
}

.ucenter_main {
  min-height: 500px;
}


.rc_main {
  padding: 36px 40px 46px;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box; /* 确保 padding 不会撑大容器宽度，防止溢出 */
}

.table-container {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}

.rc_table {
  width: 100%;
  margin-top: 10px;
  table-layout: fixed;
  min-width: 900px;
}

/* 表格单元格内容过长时，超出部分省略，避免撑破容器 */
.rc_table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
